import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/interview-sessions/`
  },

  getAllocatedStudents(interviewSessionId: number) {
    return axios.get<
      IDataResponse<Domain.Students.Resources.ApiV3.StudentSimpleResource[]>,
      IDataResponse<Domain.Students.Resources.ApiV3.StudentSimpleResource[]>
    >(this.baseUrl() + `${interviewSessionId}/allocated-students`)
      .then(data => data.data)
  },
}
